import { routes } from "../../../constants/routes";
import DownloadIcon from "../../../assets/icons/download.svg"
import ViewIcon from '../../../assets/icons/eye-light.svg'
export const breadcrumbLink = [
  {
    label: "All QR Codes",
    link: routes.QRCODELIST,
    handleClick: () => { },
  },
];

export const handlePrint = async (url: any,formName:any) => {
  const printContainer = document.createElement('div');
  printContainer.id = 'qr-print-container';
  printContainer.innerHTML = `
    <div style="text-align: center; margin: 20px;">
      <h2>${formName} QR</h2>
      <img src="${url}" style="max-width: 100%; height: auto;" />
    </div>
  `;
  const printStyles = document.createElement('style');
  printStyles.innerHTML = `
    @media print {
      body * {
        visibility: hidden;
      }
      #qr-print-container, #qr-print-container * {
        visibility: visible;
      }
      #qr-print-container {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
      }
    }
  `;

  // Append to body
  document.head.appendChild(printStyles);
  document.body.appendChild(printContainer);

  // Trigger print
  window.print();

  // Clean up
  document.head.removeChild(printStyles);
  document.body.removeChild(printContainer);
};

export  const handleDownload = async (url:any) => {
    if (!url) return;
      const a = document.createElement('a');
      a.href = url;
      a.download = 'qr-code.png';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
};

export const actionOptions = () => {
  return [
    {
      label: "View",
      value: "View",
      src: ViewIcon,
      id: 1,
      tooltipText: "",
    },
    {
      label: "Download",
      value: "Download",
      src: DownloadIcon,
      id: 2,
      tooltipText: "",
    },
  ];
};